import { I18n } from "@assets/strings";
import React from "react";
import { Link } from "react-router";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { useMyOrganizations } from "@domain/organization/hooks";
import { ClosableModal } from "@ui/modals/closableModal";
import { alpha } from "@ui/styles/utils";
import { Primary } from "@ui/components/containers/primary";
import { DeleteIconBig } from "@ui/components/icons";
import { ProfilePicture } from "@ui/components/profile/profilePicture";
import { BigRow, BigRowWrapper } from "@ui/components/rows";

interface OrganizationsModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
}
export const OrganizationsModal: React.FC<OrganizationsModalProps> = ({ close, ...htmlProps }) => {
	const { result: organizations, loading } = useMyOrganizations();

	return (
		<Container close={close} title={I18n.t("profile.organizations.title")} {...htmlProps}>
			<BigRowWrapper>
				<Link onClick={close} to={Path.NewOrganization}>
					<Row>
						<NewButton>
							<DeleteIconBig />
						</NewButton>
						<Primary>
							<b>{I18n.t("profile.organizations.new")}</b>
						</Primary>
					</Row>
				</Link>
			</BigRowWrapper>
			{organizations.map((organization) => (
				<BigRowWrapper key={organization.id}>
					<Link onClick={close} to={Path.Organization(organization)}>
						<Row>
							<ProfilePicture picture={organization.avatar} fallbackType={organization.type} />
							<Primary>
								<b>{organization.primaryName}</b>
							</Primary>
						</Row>
					</Link>
				</BigRowWrapper>
			))}
			{loading && <ClipLoader />}
		</Container>
	);
};

const Container = styled(ClosableModal)`
	align-items: stretch;

	min-height: 600px;
	@media (max-width: 900px) {
		min-height: 400px;
	}
`;

const NewButton = styled.div`
	background-color: ${({ theme }) => theme.colors.primary};
	box-shadow: 0 2px 14px 0 ${({ theme }) => alpha(theme.colors.primary, 0.6)};
	padding: 15px;
	svg  {
		width: 20px;
		height: 20px;
		transform: rotate(45deg);
		path {
			fill: ${({ theme }) => theme.colors.white};
		}
	}
`;

const Row = styled(BigRow)`
	cursor: pointer;
`;
